<mat-card class="panel mat-elevation-z6">
  <!-- Loading: barra fina arriba, no tapa los controles -->
  @if (loading()) {
    <mat-progress-bar mode="indeterminate" color="primary" class="panel-bar" />
  }

  <div class="panel-in">
    <!-- Encabezado -->
    <div class="panel-head">
      <mat-icon class="panel-head-ic">campaign</mat-icon>
      <span class="panel-title">Sirenas</span>
      <span class="grow"></span>
      <span class="panel-count">{{ sirenas() }}</span>
    </div>

    <!-- Buscar dirección -->
    <div class="field">
      <span class="field-label">Buscar dirección</span>
      <app-autocomplete-direccion
        (direccionChange)="selectDireccion($event)"
        class="full"
      />
    </div>

    <!-- Filtro cliente -->
    <div class="field">
      <span class="field-label">Clientes</span>
      <ng-select
        [items]="clientes"
        [(ngModel)]="clientesSeleccionados"
        [hideSelected]="true"
        placeholder="Todos los clientes"
        [searchable]="true"
        bindLabel="nombre"
        bindValue="_id"
        [multiple]="true"
        appendTo="body"
        (change)="changeCliente($event)"
        class="full"
      />
    </div>

    <!-- Filtro estado -->
    <div class="field">
      <span class="field-label">Estado</span>
      <ng-select
        [items]="estados"
        [(ngModel)]="estadoSeleccionado"
        [hideSelected]="true"
        placeholder="Online y Offline"
        bindLabel="nombre"
        bindValue="value"
        appendTo="body"
        (change)="changeEstado($event)"
        class="full"
      />
    </div>

    <!-- Capas -->
    <div class="toggles">
      <mat-slide-toggle
        color="primary"
        [(ngModel)]="mostrarSirenas"
        (change)="changeMostrarSirenas($event)"
        >Sirenas</mat-slide-toggle
      >
      <mat-slide-toggle
        color="primary"
        [(ngModel)]="mostrarClientes"
        (change)="changeMostrarClientes($event)"
        >Zonas</mat-slide-toggle
      >
    </div>
  </div>
</mat-card>
